import { render, staticRenderFns } from "./CampaignProfiles.vue?vue&type=template&id=274e9051&"
import script from "./CampaignProfiles.vue?vue&type=script&lang=js&"
export * from "./CampaignProfiles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports